import { render, staticRenderFns } from "./SignSuccess.vue?vue&type=template&id=6fa20a13&"
import script from "./SignSuccess.vue?vue&type=script&lang=ts&"
export * from "./SignSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports